export default function getRefs() {
    return {
        searchForm: document.querySelector('#search-form'),
        galleryContainer: document.querySelector('.gallery'),
        topBtn: document.querySelector('.btn-top'),
    }
};